export default function Marketing() {
  
    return (
      <div className='Marketing'>
        <p>Želite li pouzdanog partnera u medijskom prostoru, Radio Megaton je savršeno rješenje i ključna karika za plasman vaših proizvoda i usluga te promociju djelatnosti u Varaždinskoj i Međimurskoj županiji.</p>
        <p>Naši stalni klijenti znaju da će kod nas dobiti najbolje rezultate oglašavanja, razmjerno uloženom iznosu. Savjetujemo ih kroz personaliziran pristup, čime se usluga prilagođava željama i potrebama djelatnosti koju klijent obavlja.</p>
        <p>Prepoznatljivost i kvaliteta naših vokala, stručnost montaže i tehnička izvedba te kvalitetno pripremljeni materijal za realizaciju spotova, nagradnih igara, gostovanja u programu i raznovrsnost projekata koje odrađujemo, garancija su vrhunski odrađenog angažmana čime se polučuju maksimalni rezultati.</p>
        <p>Godinama imamo stabilnu slušateljsku jezgru, a visoka prosječna slušanost i dosezi potvrda su da smo s razlogom “Vaš najslušaniji”.</p>
        <p>Zadovoljstvo naših klijenata naša je najbolja preporuka. Uvijek na usluzi – Vaš savjetnik, partner i prijatelj – marketing Radija Megaton!</p>
        <br/>
        <p>Za detaljnije informacije o oglašavanju, kao i za konkretne dogovore, kontaktirajte nas:</p>
        <p><b>PLANEX RADIO d.o.o.</b></p>
        <p><b>Varaždinska 49A, Cargovec, 42205 Vidovec</b></p>
        <p><b>telefon:</b> 042/209-004</p>
        <p><b>mail:</b> marketing@radiomegaton.hr</p>
        <p><b>OIB:</b> 50184816348</p>
        <p><b>IBAN:</b> HR3023600001101737858    Zagrebačka banka d.d.</p>
      </div>
    );
  }